import {
  FacebookIcon,
  InstagramIcon,
  InstagramOutlinedIcon,
  TelegramIcon,
  TelegramOutlinedIcon,
  TikTokIcon,
  XIcon,
  YouTubeIcon,
} from '@repo/icons';
import { type TenantSettings } from '@repo/tenancy/types';
import { cn } from '@repo/utils/cn';

interface FooterLinkItem {
  name?: string;
  Icon?: React.FC;
  href: string;
}

interface FooterLink {
  id: string;
  title?: string;
  items: FooterLinkItem[];
  className?: string;
}

export const SocialIconsMap: any = {
  x: XIcon,
  tiktok: TikTokIcon,
  youtube: YouTubeIcon,
  facebook: FacebookIcon,
  telegram: TelegramIcon,
  instagram: InstagramIcon,
  telegramOutlined: TelegramOutlinedIcon,
  instagramOutlined: InstagramOutlinedIcon,
} as const;

export const getFooterSocialItems = (tenantSettings: TenantSettings) => {
  const items = tenantSettings?.socialLinks;
  return [
    {
      id: 'join-our-community',
      // title: '',
      className: cn(items?.length > 3 ? 'grid grid-cols-3' : 'flex', 'sm:flex items-center justify-end gap-2'),
      items: items.map(({ type, link }) => ({
        Icon: SocialIconsMap[type],
        href: link,
      })),
    },
  ] as FooterLink[];
};
